import { CardAPI, GeorgeBusinessAPI, computed, debug } from "aaa";
import { action, observable } from "mobx";
import { CardAPIClient, GeorgeBusinessAPIClient } from "network/APIClient";
import { ContactsStore } from "stores/ContactsStore";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { ISigningInfo } from "types/signing";
import { ITeamcardLinkageCardData } from "types/teamcardLinkage";
import { gba } from "util/georgeBusinessAdapter";

export class TeamcardLinkageStore {
    @observable contactsStore: ContactsStore;
    @observable _isLoading = false;// true;

    @observable invitationData?: ITeamcardLinkageCardData;

    // Needed only for platforms using PdfViewer component for rendering (currently only Android)
    pdfData?: Uint8Array;

    @observable termsDownloaded = false;
    @observable contractDownloaded = false;
    @observable dataProtectionDownloaded = false;
    @observable fernFingDownloaded = false;
    @observable agreementChecked = false;

    @observable signInfo?: ISigningInfo;

    @observable communicationId?: string;
    @observable customErrorType: "INVALID_FIELD" | "UNMATCHED" = "UNMATCHED";

    constructor() {
        this.contactsStore = new ContactsStore();
    }

    @computed get isLoading() {
        return this._isLoading
            || this.contactsStore.isLoading;
    }

    @action async loadData(): Promise<"customError" | "genericError" | undefined> {
        this._isLoading = true;

        try {
            if (externalInterfaceStore.invitationId) {
                const response = await gba.matchInvitation(externalInterfaceStore.invitationId);
                debug.log("[TeamcardLinkageStore] invitation match", response);
            } else {
                return "customError";
            }
        } catch (error) {
            debug.log("[TeamcardLinkageStore] match invitation error:", error);
            if (error.response?.errors && Array.isArray(error.response.errors)) {
                const errors = error.response.errors;

                // Check for specific error types
                if (errors.some((e: { error?: string }) => e?.error === "FIELD_INVALID")) {
                    debug.log("[TeamcardLinkageStore] FIELD_INVALID error:", error);
                    this.customErrorType = "INVALID_FIELD";
                    return "customError";
                }

                if (errors.some((e: { error?: string }) => e?.error === "INVALID" || e?.error === "UNMATCHED")) {
                    debug.log("[TeamcardLinkageStore] INVALID or UNMATCHED error:", error);
                    this.customErrorType = "UNMATCHED";
                    return "customError";
                }
            }
            return "genericError";
        }

        try {
            await this.contactsStore.load();

            const target = CardAPI.getInvitationData(externalInterfaceStore.invitationId);
            this.invitationData = await CardAPIClient.requestType(target);
            debug.log("[TeamcardLinkageStore] invitation data", this.invitationData);

        } catch (error) {
            debug.log("[TeamcardLinkageStore] loadData error:", error);
            return "genericError";
        }

        this._isLoading = false;
    }

    @action async acceptInvitation() {
        if (!externalInterfaceStore.invitationId || !this.contactsStore.selectedEmailAddressId) {
            return;
        }

        try {
            const target = CardAPI.acceptInvitation(externalInterfaceStore.invitationId, this.contactsStore.selectedEmailAddressId);

            const response = await CardAPIClient.requestType(target);
            this.signInfo = response.signInfo;
        } catch (error) {
            debug.log("[TeamcardLinkageStore] acceptInvitation error:", error);
            throw error;
        }
    }

    @action async requestSMSCode() {
        if (!externalInterfaceStore.invitationId) {
            return;
        }

        try {
            this._isLoading = true;
            const target = GeorgeBusinessAPI.postTeamCardLinkageSMSOtp(externalInterfaceStore.invitationId);
            const response = await GeorgeBusinessAPIClient.requestType(target);

            this.communicationId = response.communicationId;

        } catch (error) {
            debug.log("[TeamcardLinkageStore] requestSMSCode error:", error);
            throw error;
        } finally {
            this._isLoading = false;
        }
    }

    @action async verifySMSCode(code: string) {
        if (!externalInterfaceStore.invitationId || !this.communicationId) {
            return;
        }

        try {
            const target = GeorgeBusinessAPI.postTeamCardLinkageSMSOtpVerify(externalInterfaceStore.invitationId, code, this.communicationId);
            return await GeorgeBusinessAPIClient.requestType(target);
        } catch (error) {
            debug.log("[TeamcardLinkageStore] verifySMSCode error:", error);
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/teamcardLinkage/TeamcardLinkageStore.tsx